/**
 * Get the localized route name.
 *
 * @util
 * @param name - The name of the route.
 * @param locale - The locale string (e.g., 'us', 'pl', 'pl-en').
 * @returns The localized route name.
 * @__NO_SIDE_EFFECTS__
 */
export function getLocalizedRouteName(name, locale) {
    return `${name}__${locale}`;
}
//# sourceMappingURL=getLocalizedRouteName.js.map